import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, imgSrc, errMsg } from "@/lib/api";

export const ImageUpload = ({ value, onChange }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try { const r = await http.post("/admin/upload", fd); onChange(r.data.path); toast.success("Imagem enviada"); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className="flex items-center gap-4">
      <div className="w-24 h-24 rounded-xl overflow-hidden bg-white/5 border border-white/10 shrink-0">
        {value ? <img src={imgSrc(value)} alt="" className="w-full h-full object-cover" data-testid="product-image-preview" /> : <div className="w-full h-full grid place-items-center text-slate-600"><ImagePlus className="w-6 h-6" /></div>}
      </div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid="product-image-file-input" />
      <button type="button" onClick={() => ref.current.click()} disabled={busy} data-testid="product-image-upload-button"
        className="h-10 px-4 rounded-full border border-white/15 hover:bg-white/10 text-sm inline-flex items-center gap-2 disabled:opacity-50">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ImagePlus className="w-4 h-4" />} {value ? "Trocar imagem" : "Enviar imagem"}
      </button>
    </div>
  );
};
